// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"12fc4b21","202":"3c5920e3","369":"f8ef6924","378":"e3c217b9","497":"871e5488","506":"ece81dae","573":"a3c9ac30","609":"2ffed382","779":"9d338fe0","819":"5dd3d330","845":"ce15f113","883":"4d8aef0e"}[chunkId] + ".chunk.js";
};